const STORAGE_KEY = 'pandora-creator-autosave';

export default store => {
  store.subscribe((mutation, state) => {
    if (mutation.type.startsWith('cart/')) {
      let wardrobesWithoutScreenshots = state.cart.wardrobeList.map(item => {
        const { screenshots, ...rest } = item;
        return rest;
      })
      const stateToSave = {
        wardrobeList: wardrobesWithoutScreenshots,
        timestamp: Date.now()
      };

      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(stateToSave));
      } catch (e) {
        console.error('Błąd zapisu localStorage:', e);
      }
    }
  });
};
